module.exports = __webpack_public_path__ + "img/112.397aecc9.png";